/* MojaPizza – progress bar do odklepa dobroimetja */
import Cart from "cart-store";

import { formatMoney } from "utils";

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : "";
};

class CreditUnlockBar extends HTMLElement {
    connectedCallback() {
        this.code = (this.getAttribute("code") || "").toUpperCase();
        this.minimumValue = Number(this.getAttribute("minimum-value"));
        this.value = Number(this.getAttribute("value"));
        this.endsAt = Date.parse(this.getAttribute("ends-at") || "");
        this.hasCode = this.hasAttribute("has-code");
        this.amountLeftElement = this.querySelector("[data-amount-left]");
        this.progressText = this.querySelector('[data-state="progress"]');
        this.unlockedText = this.querySelector('[data-state="unlocked"]');
        this.fill = this.querySelector(".credit-unlock-bar__fill");

        this.#update();
        this.unsubscribe = Cart.subscribe((state) => {
            const cart = state.cart;
            if (!cart) return;
            const cartCodes = (cart.discount_codes || []).map((d) => String(d.code || "").toUpperCase());
            this.hasCode = this.hasCode || cartCodes.includes(this.code);
            this.value = cart.items_subtotal_price ?? cart.total_price;
            this.#update();
        });
    }

    disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
    }

    #isEligible() {
        if (!Number.isNaN(this.endsAt) && Date.now() > this.endsAt) return false;
        const cookieCode = getCookie("discount_code").toUpperCase();
        return this.hasCode || cookieCode === this.code;
    }

    #update() {
        if (!this.#isEligible() || this.value <= 0) {
            this.hidden = true;
            return;
        }
        this.hidden = false;

        const amountLeft = Math.max(this.minimumValue - this.value, 0);
        const progress = Math.min(Math.round((this.value / this.minimumValue) * 100), 100);
        const unlocked = amountLeft === 0;

        this.amountLeftElement.innerHTML = formatMoney(amountLeft, window.theme.money_format);
        this.progressText.hidden = unlocked;
        this.unlockedText.hidden = !unlocked;
        this.classList.toggle("is-unlocked", unlocked);
        this.fill.style.setProperty("--progress", `${progress}%`);
    }
}

if (!customElements.get("credit-unlock-bar")) {
    customElements.define("credit-unlock-bar", CreditUnlockBar);
}
